module.exports = __webpack_public_path__ + "img/003.5a049f9e.png";